var render, staticRenderFns
import script from "./user_management.vue?vue&type=script&lang=js"
export * from "./user_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2145f7ce')) {
      api.createRecord('2145f7ce', component.options)
    } else {
      api.reload('2145f7ce', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_management/user_management.vue"
export default component.exports